import GeoJsonSource from 'src/services/geoJson/GeoJsonSource';

export default class ActivityDetailsVehicleSource extends GeoJsonSource {
  /** @var {string} id */
  static id = 'activity-details-vehicle-source';

  /**
   * @param {import('src/models/GeoJsonFeature').default[]} features
   */
  getConfig(features = []) {
    return Object.freeze({
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        id: this.getId(),
        features,
      },
    });
  }
}
